/**
 * Api 그룹 브릿지 목데이터
 */

import type { ApiGroup } from './types'

// Api group mock responses
export const apiMocks: Record<keyof ApiGroup, any> = {
  sendPostback: null,
  requestParticipate: {
    clickKey: 'mock-click-key-12345',
    landingUrl: 'https://www.google.com',
    completeDelayTime: 10
  }
}
